import React from 'react';
import { Layout } from './Layout';
import { Attention } from '../atoms/Attention';

export const InconsistencyExceptionPage = () => {
  // the same definition as rmp-bff
  const OMNI_SERVICE_API_LOGOUT_REDIRECT_URI =
    'https://member.id.rakuten.co.jp/rms/nid/logout?l-id=pc_header_memberinfo_popup_logout';
  return (
    <Layout>
      <div style={{ backgroundColor: '#fff' }}>
        <Attention title="ユーザーが一致しませんでした">
          <a href={OMNI_SERVICE_API_LOGOUT_REDIRECT_URI}>ログアウト</a>
          後に再ログインしてください。
        </Attention>
      </div>
    </Layout>
  );
};
